import moment from 'moment'

export type OptionsType = {
  withWeek?: boolean
  withSecond?: boolean
}

const defaultOptions: OptionsType = {
  withWeek: false,
  withSecond: false,
}

const formatDateTime: (
  date?: Date,
  options?: Partial<OptionsType>
) => string = (date, options = {}) => {
  if (!date) {
    return ''
  }

  const actualOptions = Object.assign({}, defaultOptions, options)

  const weekFormat = actualOptions.withWeek ? ' (ddd) ' : ' '
  const secondFormat = actualOptions.withSecond ? ':ss' : ''

  const format = `LL${weekFormat}HH:mm${secondFormat}`

  return moment(date).format(format)
}

export default formatDateTime
